import React from "react";
import Delete from "../../deleteModal";
import dompurify from "dompurify";
import { withRouter } from "react-router-dom";

class Link extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      description: this.props.form.description,
    };
    this.formatDate = this.formatDate.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    this.setState({ showModal: !this.state.showModal });
  }
  componentDidMount() {
    document.getElementsByClassName("description").forEach((description) => {
      description.getElementsByTagName("a").forEach((link) => {
        link.setAttribute("target", "_blank");
      });
    });
    // console.log(document.getElementsByTagName('a'));
  }

  formatDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    return `${day}.${month}.${year}`;
  }
  render() {
    return (
      <div>
        <Delete
          onClose={this.onClose}
          showModal={this.state.showModal}
          instanceName="form"
          instance={this.props.form}
        ></Delete>
        <li className="link">
          <h5>
            <a
              onClick={() => {
                this.props.history.push("/form/view/" + this.props.form.id);
              }}
            >
              {this.props.highlight(this.props.form.title)} (
              {this.formatDate(new Date(this.props.form.created))})
            </a>
          </h5>
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html:
                this.state.description !== undefined
                  ? dompurify.sanitize(this.state.description)
                  : "Form description is not provided.",
            }}
          ></div>
          <div className="description">
            {this.props.form.tags !== undefined
              ? this.props.form.tags.map((tag) => (
                  <button
                    onClick={() => this.props.addTag(tag)}
                    className="tag"
                    key={tag}
                  >
                    {tag}
                  </button>
                ))
              : ""}
          </div>
        </li>
      </div>
    );
  }
}

export default withRouter(Link);
